import React, { useEffect, useState } from 'react';
import MondayDate from '@/components/data/date/MondayDate';

const WeekNavigation = ({ weeks }) => {
  const [active, setActive] = useState('');
  const weekDates = weeks.map(([date]) => date).join(',');

  useEffect(() => {
    const sections = document.querySelectorAll('.availability-week[id]');
    if (!sections.length || !('IntersectionObserver' in window)) return undefined;

    const observer = new IntersectionObserver(
      entries => {
        const visible = entries.filter(entry => entry.isIntersecting).sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);
        if (visible.length) setActive(visible[0].target.id);
      },
      { rootMargin: '-115px 0px -60% 0px', threshold: 0 }
    );
    sections.forEach(section => observer.observe(section));
    return () => observer.disconnect();
  }, [weekDates]);

  if (!weeks.length) return null;

  return (
    <nav className='week-navigation' aria-label='Jump to week'>
      <span className='week-nav-label'>Jump to week</span>
      <div className='week-nav-links'>
        {weeks.map(([date, report]) => {
          const id = `week-${date}`;
          return (
            <a key={date} href={`#${id}`} className={active === id ? 'active' : ''} aria-current={active === id ? 'location' : undefined} onClick={() => setActive(id)}>
              <span>{MondayDate.formatToUIDate(date)}</span>
              <small aria-label={`${report.length} professionals`}>{report.length}</small>
            </a>
          );
        })}
      </div>
    </nav>
  );
};

export default WeekNavigation;
